import React from "react";

export default props => (
  <footer className="main">
    <section className="separator text-center">
    </section>
  </footer>
);
